var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"application-detail"},[(!_vm.isExists && _vm.loaded)?[_c('not-found404',{attrs:{"text":"Заявление не найдено"}})]:_c('item-detail')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }